export default __webpack_public_path__ + "static/media/K420_RoHS.0b7621d7.pdf";